import { GetNewGuid } from '../../../utils/helpMain'
import { useRef, useEffect} from 'react'
const CheckBox = ({
    field = '',
    label = '',
    value = false,
    isRequired = true,
    onChange,
    onClickLabel
}: IPropsCheckBox) => {
    let inpuReqtRef = useRef<HTMLInputElement>(null);

    const change = (e: any) => {
        let event = { target: {} as any };
        event.target.value = e.target.checked;
        event.target.name = field;
        if (e.target)
            onChange(field, e.target.checked);
    }

    useEffect(() => {
        if (isRequired) {
            inpuReqtRef.current?.setCustomValidity("");
            if(value === false)
            {
                inpuReqtRef.current?.setCustomValidity("Campo requerido");
            }
        }
    })

    return (
        <div className="checkbox-g-auto-cr mt-30 mb-5">
        <div className="checkbox-auto-cr">
            <input type="checkbox"  checked={value} onChange={change} name={field} id={`checkbox-auto-cr_${field}`} />                
            <label htmlFor={`checkbox-auto-cr_${field}`}></label>
            {isRequired && (
                <input ref={inpuReqtRef} type="radio" name={GetNewGuid()} className="sg-switch-validator" />
            )}
        </div>
        <span  className="lbl-checkbox-auto-cr" onClick={onClickLabel}>
            {label}
        </span>
    </div>
    );
}

export { CheckBox };